<template>
  <ul
    v-if="displayedColors.length > 0"
    :aria-label="
      i18n(translations.availableColors, {
        colors: colors.map((c) => c.name).join(', '),
      })
    "
    class="flex list-none items-center justify-center"
    :class="classes[size].gap"
  >
    <li v-for="color in displayedColors" :key="color.name">
      <RevColorSwatch
        :aria-label="i18n(translations.colorSwatches, { color: color.name })"
        :color="color.value || color.name"
        role="img"
        :size="size as SizesEnum"
        :title="i18n(translations.colorSwatches, { color: color.name })"
      />
    </li>
    <li
      v-if="additionalColorsCount > 0"
      class="text-action-default-hi"
      :class="classes[size].text"
    >
      +{{ additionalColorsCount }}
      <span class="sr-only">{{ i18n(translations.moreColors) }}</span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { tw } from '@backmarket/utils/string/tw'
import { RevColorSwatch } from '@ds/components/ColorSwatch'
import { SizesEnum } from '@ds/components/ColorSwatch/ColorSwatch.constant'

import translations from './ColorSwatches.translations'

const i18n = useI18n()

const MAX_COLORS = 4

const {
  colors,
  maxColors = MAX_COLORS,
  size = 'small',
} = defineProps<{
  colors: Array<{ name: string; value?: string }>
  size?: 'small' | 'medium'
  maxColors?: number
}>()

const classes = {
  small: {
    gap: '',
    text: tw`caption`,
  },
  medium: {
    gap: tw`gap-x-4`,
    text: tw`body-2-bold`,
  },
}

const displayedColors = computed(() => colors.slice(0, maxColors))
const additionalColorsCount = computed(() => colors.slice(maxColors).length)
</script>
